/**
 * Author: TIANYONG90
 * Description: 自动初始化带有 data-ty-swiper 属性的轮播图组件
 * Dependency: Swiper.js (Global)
 */

// 空片段没有页内目标；仅清理尾随 #，保留查询参数和有意义的锚点。
if (window.location.href.endsWith('#')) {
  window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
}

(function () {
  'use strict';

  const SELECTOR = '[data-ty-swiper="true"]';

  // 核心初始化逻辑
  function initTySwipers() {
    // 检查 Swiper 是否已加载
    if (typeof Swiper === 'undefined') {
      console.warn('TY-SWIPER: Swiper is not defined. Please ensure Swiper.js is loaded.');
      return;
    }

    const elements = document.querySelectorAll(SELECTOR);

    elements.forEach(el => {
      // 防止重复初始化
      if (el.classList.contains('swiper-initialized')) return;

      // 1. 获取基础配置 (Data Attributes)
      // 使用 ty- 前缀保持命名纯净
      const slidesPerView = parseFloat(el.getAttribute('data-ty-slides-per-view')) || 1;
      const spaceBetween = parseFloat(el.getAttribute('data-ty-space-between')) || 0;
      const loop = el.getAttribute('data-ty-loop') === 'true';
      const autoplayDelay = parseInt(el.getAttribute('data-ty-autoplay'), 10) || 0;
      const autoHeight = el.getAttribute('data-ty-auto-height') === 'true';
      const navigationId = el.getAttribute('data-ty-nav-id'); // 用于绑定特定的翻页按钮
      const paginationId = el.getAttribute('data-ty-pag-id'); // 用于绑定特定的分页器

      // 2. 构建 Swiper 配置对象
      let config = {
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        loop: loop,
        autoHeight: autoHeight,
        grabCursor: true,
        // 默认断点逻辑，可根据需求修改
        breakpoints: {
          640: {
            // 移动端
            slidesPerView: 1,
          },
          768: {
            // 平板/桌面
            slidesPerView: slidesPerView, // 恢复到设定的值
          },
        },
        on: {
          init: function () {
            el.classList.add('ty-loaded'); // 用于处理加载时的抖动(CLS)
          },
        },
      };

      // 3. 处理自动播放
      if (autoplayDelay > 0) {
        config.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      // 4. 处理导航按钮 (支持查找容器内部或外部的特定ID)
      if (navigationId) {
        config.navigation = {
          nextEl: `.ty-button-next-${navigationId}`,
          prevEl: `.ty-button-prev-${navigationId}`,
        };
      } else {
        // 默认查找容器内部
        config.navigation = {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        };
      }

      // 5. 处理分页器
      if (paginationId) {
        config.pagination = {
          el: `.ty-pagination-${paginationId}`,
          clickable: true,
        };
      } else {
        config.pagination = {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        };
      }

      // 6. 允许通过 JSON 传递复杂参数 (高级扩展)
      // 例如 HTML 中写: data-ty-advanced='{"effect": "fade"}'
      const advancedConfig = el.getAttribute('data-ty-advanced');
      if (advancedConfig) {
        try {
          const jsonConfig = JSON.parse(advancedConfig);
          config = { ...config, ...jsonConfig };
        } catch (e) {
          console.error('TY-SWIPER: JSON parse error', e);
        }
      }

      // 7. 实例化
      new Swiper(el, config);
    });
  }

  // 页面加载完成执行
  document.addEventListener('DOMContentLoaded', initTySwipers);

  // 兼容 Shopify Theme Editor (当你在后台修改 Section 时，重新触发 JS)
  document.addEventListener('shopify:section:load', initTySwipers);
})();

(function () {
  'use strict';

  document.addEventListener('input', event => {
    const input = event.target.closest?.('.ty-split-compare__range');
    if (!input) return;

    const position = Math.min(100, Math.max(0, Number(input.value) || 0));
    const comparison = input.closest('[data-content-block="split-compare"]');

    // 原生 range 统一处理鼠标、触摸、触控笔和键盘；这里只同步无布局抖动的 CSS 变量。
    comparison?.style.setProperty('--split-position', `${position}%`);
  });
})();

(function () {
  'use strict';

  const PRODUCT_DETAILS_SELECTOR = '.productView-details';
  const FINAL_PRICE_SELECTOR = '.productView-subtotal .money-subtotal';
  const BUNDLER_QUANTITY_SELECTOR = 'input[name="bundle_quantity"]:checked';
  const variantCache = new Map();

  function getSelectedVariantId(productDetails) {
    return productDetails.querySelector('form[action*="/cart/add"] input[name="id"]')?.value || '';
  }

  function getProductHandle(productDetails) {
    return productDetails.closest('[data-product-handle]')?.dataset.productHandle || '';
  }

  function getSelectedQuantity(productDetails) {
    const quantity = Number.parseInt(productDetails.querySelector(BUNDLER_QUANTITY_SELECTOR)?.value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : null;
  }

  function getTyBundlerBundles() {
    if (typeof window.bndlr?.getBundles !== 'function') return [];

    try {
      return window.bndlr.getBundles();
    } catch (error) {
      console.warn('TY-BUNDLER: Unable to read Bundler configuration.', error);
      return [];
    }
  }

  function getTyProductBundle(bundles, handle, variantId) {
    return bundles
      .filter(bundle => {
        if (bundle?.minimum_requirements !== 'volume_discounts' || bundle.show_bundle === 'false') return false;
        if (bundle.product_target_type === 'all_products') return true;

        const configuredProduct = Object.values(bundle.products || {}).find(product => product.handle === handle);
        if (!configuredProduct) return false;
        if (bundle.product_level !== 'variant') return true;

        return Boolean(configuredProduct.variants?.[variantId]);
      })
      .sort((first, second) => Number(second.priority || 0) - Number(first.priority || 0))[0];
  }

  function getTyVolumeDiscount(bundle, quantity) {
    return bundle?.volume_discounts?.find(discount => {
      const minimum = Number(discount.min_items || 0);
      const maximum = discount.max_items === null ? Number.POSITIVE_INFINITY : Number(discount.max_items);

      if (discount.range_type === 'fixed_quantity') return quantity === minimum;
      return quantity >= minimum && quantity <= maximum;
    });
  }

  async function getTyVariant(variantId) {
    if (!variantCache.has(variantId)) {
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(`${root}variants/${encodeURIComponent(variantId)}.js`, window.location.origin);
      const currency = window.Shopify?.currency?.active;
      const country = window.Shopify?.country;

      if (currency) url.searchParams.set('currency', currency);
      if (country) url.searchParams.set('country', country);

      // 直接按字符串形式的变体 ID 请求价格，避免 Shopify 大整数 ID 在 JSON 解析时丢失精度。
      variantCache.set(
        variantId,
        fetch(url.toString(), { credentials: 'same-origin' }).then(response => {
          if (!response.ok) throw new Error(`Shopify variant request failed: ${response.status}`);
          return response.json();
        }),
      );
    }

    return variantCache.get(variantId);
  }

  function calculateTyBundlerTotal(unitPrice, quantity, discount) {
    const originalTotal = unitPrice * quantity;
    const discountValue = Number(discount.discount_value || 0);

    if (discount.discount_type === 'percentage') {
      return Math.max(0, Math.round(originalTotal * (1 - discountValue / 100)));
    }

    if (discount.discount_type === 'fixed_price') {
      return Math.max(0, Math.round(discountValue * 100));
    }

    if (discount.discount_type === 'fixed_amount') {
      return Math.max(0, originalTotal - Math.round(discountValue * 100));
    }

    return originalTotal;
  }

  function updateFinalPrice(productDetails, totalPrice) {
    if (!Number.isFinite(totalPrice) || typeof window.Shopify?.formatMoney !== 'function') return;

    const formattedPrice = window.Shopify.formatMoney(totalPrice, window.money_format);
    const decoder = document.createElement('textarea');
    decoder.innerHTML = formattedPrice;
    const displayPrice = decoder.value;

    const targets = productDetails.querySelectorAll(FINAL_PRICE_SELECTOR);
    targets.forEach(target => {
      if (target.textContent !== displayPrice) target.textContent = displayPrice;
      target.dataset.tyBundlerFinalPriceSynced = 'true';
      target.closest('.productView-subtotal')?.setAttribute('aria-live', 'polite');
    });
  }

  async function syncTyBundlerPrice(productDetails) {
    const handle = getProductHandle(productDetails);
    const variantId = getSelectedVariantId(productDetails);
    const quantity = getSelectedQuantity(productDetails);
    const bundles = getTyBundlerBundles();
    if (!handle || !variantId || !quantity || bundles.length === 0) return;

    try {
      const variant = await getTyVariant(variantId);
      const bundle = getTyProductBundle(bundles, handle, variantId);
      const discount = getTyVolumeDiscount(bundle, quantity);
      if (!discount) return;

      // 价格以分为单位计算；Bundler 的固定金额/固定总价配置以当前展示货币元为单位。
      updateFinalPrice(productDetails, calculateTyBundlerTotal(Number(variant.price), quantity, discount));
    } catch (error) {
      console.warn('TY-BUNDLER: Unable to calculate the final price.', error);
    }
  }

  function initTyBundlerPriceSync(scope = document) {
    const productDetails = scope.matches?.(PRODUCT_DETAILS_SELECTOR)
      ? scope
      : scope.querySelector?.(PRODUCT_DETAILS_SELECTOR);

    if (!productDetails) return;
    if (productDetails.dataset.tyBundlerPriceSync === 'true') {
      syncTyBundlerPrice(productDetails);
      return;
    }

    productDetails.dataset.tyBundlerPriceSync = 'true';

    const scheduleSync = () => window.requestAnimationFrame(() => syncTyBundlerPrice(productDetails));

    productDetails.addEventListener('change', event => {
      if (event.target?.matches('input[name="bundle_quantity"], form[action*="/cart/add"] input[name="id"]')) {
        scheduleSync();
      }
    });

    // Bundler 会异步注入数量选项；这里只监听结构和选中状态，不读取任何价格文本。
    const observer = new MutationObserver(scheduleSync);
    observer.observe(productDetails, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['checked'],
    });

    productDetails.tyBundlerPriceObserver = observer;
    scheduleSync();
  }

  function destroyTyBundlerPriceSync(event) {
    const productDetails = event.target?.querySelector?.(PRODUCT_DETAILS_SELECTOR);
    productDetails?.tyBundlerPriceObserver?.disconnect();
  }

  document.addEventListener('DOMContentLoaded', () => initTyBundlerPriceSync());
  document.addEventListener('bundler:loaded', () => initTyBundlerPriceSync());
  document.addEventListener('bundler:bundle_widget_created', () => initTyBundlerPriceSync());

  // Shopify 后台编辑器重载 section 时，重新绑定新注入的产品详情 DOM。
  document.addEventListener('shopify:section:load', event => initTyBundlerPriceSync(event.target));
  document.addEventListener('shopify:section:unload', destroyTyBundlerPriceSync);
})();
